/**
 * Sale prices (Oct 2026, Venus). One rounding rule for the till, the
 * website and the dialog that previews them: a sale price is rounded to the
 * nearest 100 shillings once it is 1,000 or more (45,000 − 15% = 38,250 →
 * 38,300), so a shelf price reads like one a person would write.
 */
export function salePrice(original: number, pct: number): number {
  const raw = original * (1 - Math.max(0, Math.min(90, pct)) / 100);
  if (raw >= 1000) return Math.round(raw / 100) * 100;
  return Math.max(1, Math.round(raw));
}

/** "−15%": how much cheaper a price is than the one crossed out, or null. */
export function discountPct(price: number | null | undefined, compareAt: number | null | undefined): number | null {
  const p = Number(price);
  const c = Number(compareAt);
  if (!(p > 0) || !(c > p)) return null;
  return Math.round(((c - p) / c) * 100);
}
